// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("@rails/activestorage").start();
require("channels");
require("src/contacts/background_color_change");
require("src/contacts/form_validation_scroll");
require("src/contacts/step1_button_actions");
require("src/contacts/step2_form_checkbox");
require("src/contacts/step3_button_actions");
require("src/contacts/step3_tel_email_confirm_screen_actions");
require("src/contacts/step3_form_reference_product_actions");
require("src/contacts/modal");
// require("src/contacts/step1_service_options"); NOTICE: Will use the service option again
require("src/contacts/step1_product_lots"); // NOTICE: Will use the service option again → delete

import "bootstrap";
import "@fortawesome/fontawesome-free/css/all.css";
import "../stylesheets/contacts";

$(document).ready(function(){
    $(".container").on("click", "input[type='checkbox'], input[type='radio'], .form-check-label", function(e) {
        e.stopPropagation();
    });
    $(window).keydown(function(event){
        if(event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });
});
var jQuery = require('jquery')
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
